import produce from "immer";
import { OverlayAction, CLOSE_ALL_OVERLAYS, OPEN_MENU, OPEN_FIXR_OVERLAY, CLOSE_FIXR_OVERLAY ,OPEN_SEARCH_OVERLAY, CLOSE_SEARCH_OVERLAY } from "./overlay.actions";
import OverlayRootState from "../models/redux-state.interface";

const initialState: OverlayRootState = {
    currentOverlay: undefined,
    content: undefined
};

export default (pageState = initialState, action: OverlayAction) => {
    return produce(pageState, draft => {
        switch (action.type) {
            case OPEN_MENU: {
                draft.currentOverlay = "MENU";
                draft.content = undefined;
                break;
            }
            case OPEN_SEARCH_OVERLAY: {
                draft.currentOverlay = "SEARCH_OVERLAY";
                draft.content = action.content;
                break;
            }
            case CLOSE_SEARCH_OVERLAY: {
                draft.currentOverlay = "CLOSING_SEARCH_OVERLAY";
                break;
            }
            case OPEN_FIXR_OVERLAY: {
                draft.currentOverlay = "FIXR_OVERLAY";
                draft.content = action.content;
                break;
            }
            case CLOSE_FIXR_OVERLAY: {
                draft.currentOverlay = "CLOSING_FIXR_OVERLAY";
                break;
            }
            case CLOSE_ALL_OVERLAYS: {
                draft.currentOverlay = undefined;
                draft.content = undefined;
                break;
            }
        }
    });
};